import { z } from "zod";
/**
 * `PUT /crm/lead-assignment` — any subset of the policy's switches.
 *
 * Partial so each switch saves on its own the moment it is flipped (the
 * `inventory_enabled` precedent), and strict so a typo is a 400 rather than a
 * silent no-op on a setting that decides who sees which prospect.
 */
export const updateLeadAssignmentPolicySchema = z
    .object({
    enabled: z.boolean().optional(),
    autoAssign: z.boolean().optional(),
    memberTransfer: z.boolean().optional(),
    adminOwnLeadsOnly: z.boolean().optional(),
})
    .strict()
    .refine((v) => Object.keys(v).length > 0, "Indica al menos una opción");
/** `PUT /crm/lead-assignment/members/:profileId` — in or out of the rotation. */
export const setReceivesLeadsSchema = z.object({ receivesLeads: z.boolean() }).strict();
/** `PUT /crm/leads/:id/assignee` — `null` unassigns. */
export const changeLeadAssigneeSchema = z
    .object({ profileId: z.string().uuid().nullable() })
    .strict();
//# sourceMappingURL=lead-assignment.js.map